import { cigAutoPayFailedBill, cigHdcAutoPayFailedBill } from "../builders/createCigBill";
import { getHdc1Dot5MembershipId } from "../builders/getHdc1Dot5MembershipId";
import { getHdc1Dot5MembershipDetails } from "../builders/getHdc1Dot5MembershipDetails";
import { hdcAutoPayAlertMock, insuranceAutoPayFailed } from "../builders/createInsuranceBill";
import { MockPolicyId } from "../mockPolicies";
import { getMockPolicies } from "../builders/getMockPolicies";
import { omniUsVipMember } from "../mockMembers";

import { MockPersona } from "./mockPersonas.types";

const hdcLevel = 4; // TODO: pass VIP here instead
const usPolicies: MockPolicyId[] = ["abc123"];
const canadianPolicies: MockPolicyId[] = ["dc101"];

export const barackTrudeau: MockPersona = {
  key: "barackTrudeau",
  name: "Barack Trudeau",
  description:
    "🇺🇸/🇨🇦 | Multiple policies, one with broker | HDC 1.5 VIP | Insurance Autopay failed and HDC Autopay failed",
  providerApiMockResponses: {
    cig: {
      billing: {
        fees: [],
        bills: [
          cigAutoPayFailedBill({ productNumber: canadianPolicies[0] }),
          cigHdcAutoPayFailedBill("1.5", { id: "2" }),
        ],
      },
      policies: {
        usa: getMockPolicies(...usPolicies),
        canada: getMockPolicies(...canadianPolicies),
      },
    },
    hdc: {
      fetch1Dot5MembershipId: getHdc1Dot5MembershipId("HDC01981371"),
      fetch1Dot5MembershipDetails: getHdc1Dot5MembershipDetails({
        level: hdcLevel,
      }),
    },
    esign: {
      fetchESignDocuments: [{ Id: 1, StateRegion: "MD" }],
      createESignRequest: "success",
    },
    insurance: {
      fetchEndorsement: [],
    },
    soul: {
      fetchSoul: {
        hagertyAccounts: {
          myHagertyAccount: {
            id: "1",
            loginEmail: "barack@trudeau.com",
            firstName: "Barack",
            middleName: "",
            lastName: "Trudeau",
            mailingAddress: {
              line1: "1600 Pennsylvania Ave",
              line2: "",
              city: "Washington",
              state: "DC",
              postalCode: "01000",
              country: "USA",
            },
            preferredPhone: "2023591000",
            salesforceAccounts: [
              {
                accountNumber: "123",
                id: "1",
                partnerId: null,
              },
            ],
            drivetrainAccounts: [
              {
                customerAccountLegacyKey: "000002",
                source: "USA",
                customerSourceSystemKey: "123",
                id: "1",
                partnerCustomerId: "123",
                partnerId: "UNKNOWN",
              },
              {
                customerAccountLegacyKey: "000003",
                source: "CANADA",
                customerSourceSystemKey: "123",
                id: "2",
                partnerCustomerId: "123",
                partnerId: "UNKNOWN",
              },
            ],
            identityAccounts: [],
            message: undefined,
          },
        },
      },
    },
    member: {
      fetchMember: {
        member: {
          member: omniUsVipMember,
        },
      },
    },
    billing: {
      fetchBilling: {
        bills: {
          bills: [
            insuranceAutoPayFailed({ policyNumber: canadianPolicies[0], id: "1" }),
            hdcAutoPayAlertMock({ id: "2" }),
          ],
          outstandingBalance: 1,
        },
      },
    },
    payments: {
      fetchPayEndorsementUrl: { payEndorsementUrl: "mock-url" },
    },
  },
};
